import { render, staticRenderFns } from "./TopupBuyerDialog.vue?vue&type=template&id=ed2a7e9c&"
import script from "./TopupBuyerDialog.vue?vue&type=script&lang=ts&"
export * from "./TopupBuyerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TopupBuyerDialog.vue?vue&type=style&index=0&id=ed2a7e9c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports